import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { StatisticTotalPayments } from 'src/features/statistics/types';
import type { ListDTO, ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/statistics/payments/';

interface DTO extends ListDTO {
    parkingId: string;
    from_date?: string;
    to_date?: string;
    workplace_ids?: string[];
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<StatisticTotalPayments>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export {
    RESOURCE as LIST_TOTAL_PAYMENTS_STATISTICS_RESOURCE,
    queryFn as listListTotalPaymentsStatistics,
    useQueryHook as useListTotalPaymentsStatistics,
};
